<!-- 导入弹框 - 业务独立 -->
<template>
  <div>
    <div class="choose_account">
      <div class="choose_title">投手类型：</div>
      <el-select
        v-model="pitcherType"
        style="width:250px"
        placeholder="请选择投手类型"
      >
        <el-option
          v-for="item in pitcherOptions"
          :key="item.value"
          :label="item.description"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="choose_account">
      <div class="choose_title">短剧类型：</div>
      <el-select
        v-model="type"
        style="width:250px"
        placeholder="请选择短剧类型"
      >
        <el-option
          v-for="item in dramaOptions"
          :key="item.value"
          :label="item.description"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="choose_account">
      <div class="choose_title">上传文件：</div>
      <div>
        <el-button type="primary" icon="el-icon-upload2" @click="$refs.files.click()">选择文件<input ref="files" style="display:none;" type="file" multiple accept=".xlsx" @change="changeFile"></el-button>
      </div>
      <div>{{ fileName }}</div>
    </div>
    <div style="text-align: center;margin-top: 60px;">
      <el-button
        type="primary"
        @click="savebit"
      >保存</el-button>
    </div>
  </div>
</template>
<script>
import { changduPlayletImport, getDramaTypeList } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: {},
  data() {
    return {
      fileList: [],
      fileName: '',
      file: null,
      name: '',
      book_id: '',
      type: null,
      value1: '',
      dramaOptions: [
      ],
      pitcherType: null,
      pitcherOptions: [
      ]
    }
  },
  created() {
    this.ev_getDramaTypeList()
  },
  mounted() {},
  methods: {
    async ev_getDramaTypeList() {
      const { data } = await getDramaTypeList()
      console.log('resData', data)
      this.pitcherOptions = data.pitcher_type
      this.dramaOptions = data.type
    },
    async send() {
    },
    changeFile(e) {
      this.fileName = e.target.files[0].name
      this.file = e.target.files[0]
      console.log('file', this.file)
    },
    async savebit() {
      if (!this.type) {
        this.$message.error('请选择短剧类型')
        return
      }
      if (this.fileName === '') {
        this.$message.error('请上传文件')
        return
      }
      const form = new FormData()
      form.append('file', this.file)
      form.append('type', this.type)
      form.append('pitcher_type', this.pitcherType)
      console.log('form', form)
      await changduPlayletImport(form)
      this.$message({
        message: '导入成功',
        type: 'success'
      })
      this.$emit('updatawe')
    }
  }
}
</script>
<style scoped>
.choose_account {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_title {
  width: 100px;
  text-align: right;
  min-width: 100px;
  flex-shrink: 0;
}
</style>
